export default __webpack_public_path__ + "08aad43216d8508a02d7c2d74c44bdfb.webp";